import {
  BooleanField,
  Button,
  Datagrid,
  Edit,
  EditButton,
  ExportButton,
  Filter,
  ImageField,
  Labeled,
  List,
  SaveButton, //
  Show,
  ShowButton,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useNotify,
} from "react-admin";

import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import { PopupboxContainer } from "react-popupbox";
import { MyDateField } from "../MyDateField";
import { MyDateTimeInput } from "../MyDateTimeInput";
import { BooleanInputWithConfirm } from "./component/boolean-input-with-confirm";

const EpisodeFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Programme ID" source="programme_id" alwaysOn />
  </Filter>
);

const ListActions = (props) => (
  <TopToolbar>
    <Button
      color="primary"
      component={Link}
      to={{
        pathname: "/episode-ordering",
        search: `filter=${JSON.stringify({
          programme_id: props.filterValues.programme_id,
        })}`,
      }}
      label="UPDATE EPISODE ORDERING"
    />
    <ExportButton />
  </TopToolbar>
);

export const EpisodeList = (props) => {
  return (
    <List {...props} sort={{ field: "order", order: "DESC" }} filters={<EpisodeFilter />} actions={<ListActions />}>
      <Datagrid>
        <TextField label="Episode ID" source="episode_id" sortable={false} />
        <TextField source="episode_no" sortable={false} />
        <TextField label="Name in TC" source="name_tc" sortable={false} />
        <TextField label="Name in EN" source="name_en" sortable={false} />
        <TextField source="is_preview" sortable={false} />
        <BooleanField source="enabled" sortable={false} />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};

const EpisodeTitle = ({ record }) => {
  return <span>Episode {record ? `${record.name_tc}` : ""}</span>;
};

export const EpisodeShow = (props) => (
  <Show {...props} title={<EpisodeTitle />}>
    <SimpleShowLayout>
      <Grid container>
        <Grid item sm={12} md={4}>
          <Labeled label="Episode ID">
            <TextField source="episode_id" />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={4}>
          <Labeled label="Name in TC">
            <TextField source="name_tc" />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={4}>
          <Labeled label="Name in EN">
            <TextField source="name_en" />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="Desc in TC">
            <TextField source="desc_tc" />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="Desc in EN">
            <TextField source="desc_en" />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="Free Start Time">
            <MyDateField source="free_start_time" showTime />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="Free End Time">
            <MyDateField source="free_end_time" showTime />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="Pay Start Time">
            <MyDateField source="pay_start_time" showTime />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="Pay End Time">
            <MyDateField source="pay_end_time" showTime />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="Gold Start Time">
            <MyDateField source="gold_start_time" showTime />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="Gold End Time">
            <MyDateField source="gold_end_time" showTime />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="APP/Web free start time">
            <MyDateField source="app_web_free_start_time" showTime />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="APP/Web free end time">
            <MyDateField source="app_web_free_end_time" showTime />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="APP/Web first start time">
            <MyDateField source="app_web_first_start_time" showTime />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="APP/Web first end time">
            <MyDateField source="app_web_first_end_time" showTime />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="Premium start time">
            <MyDateField source="premium_start_time" showTime disabled />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="Premium end time">
            <MyDateField source="premium_end_time" showTime disabled />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="Pay per episode start time">
            <MyDateField source="pay_per_episode_start_time" showTime disabled />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="Pay per episode end time">
            <MyDateField source="pay_per_episode_end_time" showTime disabled />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={4}>
          <Labeled label="Small">
            <ImageField source="image.small" title="" />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={4}>
          <Labeled label="Medium">
            <ImageField source="image.medium" title="" />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={4}>
          <Labeled label="Large">
            <ImageField source="image.large" title="" />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="Programme ID">
            <TextField source="programme_id" />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="Episode No">
            <TextField source="episode_no" />
          </Labeled>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="Is Preview">
            <TextField source="is_preview" />
          </Labeled>
        </Grid>
        <Grid item sm={12} md={6}>
          <Labeled label="Enabled">
            <BooleanField source="enabled" />
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  </Show>
);

export const EpisodeEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };
  return (
    <Edit {...props} onFailure={onFailure} mutationMode="pessimistic" title={<EpisodeTitle />}>
      <SimpleForm toolbar={<PostEditToolbar />}>
        <PopupboxContainer />

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="free_start_time" fullWidth />
          </Grid>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="free_end_time" fullWidth />
          </Grid>
        </Grid>

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="pay_start_time" fullWidth />
          </Grid>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="pay_end_time" fullWidth />
          </Grid>
        </Grid>

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="gold_start_time" fullWidth />
          </Grid>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="gold_end_time" fullWidth />
          </Grid>
        </Grid>

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="app_web_free_start_time" label="APP/Web free start time" fullWidth />
          </Grid>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="app_web_free_end_time" label="APP/Web free end time" fullWidth />
          </Grid>
        </Grid>

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="app_web_first_start_time" label="APP/Web first start time" fullWidth />
          </Grid>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="app_web_first_end_time" label="APP/Web first end time" fullWidth />
          </Grid>
        </Grid>

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="premium_start_time" label="Premium start time" fullWidth disabled />
          </Grid>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="premium_end_time" label="Premium end time" fullWidth disabled />
          </Grid>
        </Grid>

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="pay_per_episode_start_time" label="Pay per episode start time" fullWidth disabled />
          </Grid>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="pay_per_episode_end_time" label="Pay per episode end time" fullWidth disabled />
          </Grid>
        </Grid>

        <BooleanInputWithConfirm source="enabled" popupTitle="Disable episode?" />
        <TextField source="is_preview" />
      </SimpleForm>
    </Edit>
  );
};

// This Toolbar leave a SaveButton the same as default Toolbar but remove Delete
const PostEditToolbar = function (props) {
  return (
    <Toolbar {...props}>
      <SaveButton disabled={props.pristine} />
    </Toolbar>
  );
};
